// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.vue-container[data-v-057164ef] {
  container-type: inline-size;
  container-name: coupon-code-compornent;
  padding: 15px;
}
.vue-inner[data-v-057164ef] {
  display: flex;
  justify-content: space-around;
  background: #fff;
  padding: 35px 20px;
}
.vue-content[data-v-057164ef] {
  flex: 1;
  padding: 10px 20px;
  align-self: center;
  text-align: center;
}
.vue-divider[data-v-057164ef] {
  width: 1px;
  margin: 0 10px;
}
.vue-title[data-v-057164ef] {
  font-size: 3.6rem;
  font-weight: bold;
}
.vue-discount_off[data-v-057164ef] {
  font-size: 4.8rem;
}
.vue-title_text[data-v-057164ef] {
  font-size: 3.6rem;
}
.vue-tagline[data-v-057164ef] {
  font-size: 2.4rem;
}
.vue-promotion_label[data-v-057164ef] {
  font-size: 2.4rem;
}
.vue-code[data-v-057164ef] {
  display: flex;
}
.vue-code_field[data-v-057164ef] {
  appearance: none;
  font-size: 3.6rem;
  font-weight: bold;
  color: #fff;
  padding: 5px;
  margin: 0;
  border: none;
  border-radius: 0;
  outline: none;
  text-align: center;
  width: 100%;
}
.vue-copy_btn[data-v-057164ef] {
  appearance: none;
  user-select: none;
  touch-action: manipulation;
  outline: 0;
  -webkit-tap-highlight-color: transparent;
  padding: 5px 20px;
  font-size: 2.4rem;
  color: #fff;
  border: none;
  border-radius: 0;
  white-space: nowrap;
}
@container coupon-code-compornent (width <= 768px) {
.vue-inner[data-v-057164ef] {
    flex-direction: column;
    padding: 20px;
}
.vue-content[data-v-057164ef] {
    padding: 0;
}
.vue-content[data-v-057164ef]:first-child {
    padding-bottom: 20px;
}
.vue-divider[data-v-057164ef] {
    display: none;
}
.vue-title[data-v-057164ef] {
    font-size: 2.4rem;
}
.vue-discount_off[data-v-057164ef] {
    font-size: 3.2rem;
}
.vue-title_text[data-v-057164ef] {
    font-size: 2.4rem;
}
.vue-tagline[data-v-057164ef] {
    font-size: 1.6rem;
}
.vue-promotion_label[data-v-057164ef] {
    font-size: 1.4rem;
}
.vue-code_field[data-v-057164ef] {
    font-size: 2.4rem;
}
.vue-copy_btn[data-v-057164ef] {
    font-size: 1.4rem;
}
}
`, "",{"version":3,"sources":["webpack://./src/vue/components/common/couponCode.vue"],"names":[],"mappings":";AAyGA;EACA,2BAAA;EACA,sCAAA;EACA,aAAA;AACA;AACA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AACA;AACA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AACA;AACA;EACA,UAAA;EACA,cAAA;AACA;AACA;EACA,iBAAA;EACA,iBAAA;AACA;AACA;EACA,iBAAA;AACA;AACA;EACA,iBAAA;AACA;AACA;EACA,iBAAA;AACA;AACA;EACA,iBAAA;AACA;AACA;EACA,aAAA;AACA;AACA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AACA;AACA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,UAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AACA;AACA;AACA;IACA,sBAAA;IACA,aAAA;AACA;AACA;IACA,UAAA;AACA;AACA;IACA,oBAAA;AACA;AACA;IACA,aAAA;AACA;AACA;IACA,iBAAA;AACA;AACA;IACA,iBAAA;AACA;AACA;IACA,iBAAA;AACA;AACA;IACA,iBAAA;AACA;AACA;IACA,iBAAA;AACA;AACA;IACA,iBAAA;AACA;AACA;IACA,iBAAA;AACA;AACA","sourcesContent":["<template lang=\"pug\">\n  .vue-container(:style=\"containerStyle\")\n    .vue-inner\n      .vue-content\n        .vue-title(:style=\"textColorStyle\")\n          template(v-if=\"title\")\n            span.vue-title_text(v-text=\"title\")\n          template(v-else)\n            span.vue-discount_off(v-text=\"discount\")\n            | &nbsp;OFF Coupon\n        .vue-tagline(:style=\"textColorStyle\", v-text=\"tagline\")\n      .vue-divider(:style=\"backgroundColorStyle\")\n      .vue-content\n        .vue-promotion_label(:style=\"textColorStyle\") COUPON CODE\n        .vue-code\n          input.vue-code_field(ref=\"codeField\", :id=\"'vue-code' + _uid\", :style=\"backgroundColorStyle\", :value=\"code\", readonly, @focus=\"selectCode\", @click=\"selectCode\")\n          button.vue-copy_btn(type=\"button\", :style=\"darkenBackgroundColorStyle\", :data-clipboard-target=\"'#vue-code' + _uid\") Copy\n\n</template>\n\n<script>\nimport colorUtil from '../../util/color';\n\nexport default {\n  props: {\n    // title が指定されれば discount よりも優先\n    title: String,\n    // 割引値 % or $\n    discount: String,\n    // クーポンの概要\n    tagline: String,\n    // クーポンコード\n    code: String,\n    // テーマカラー\n    color: {\n      type: String,\n      default: '#2775A0'  // Shop base color\n    }\n  },\n\n  computed: {\n    darkenColor() {\n      return colorUtil.darken(this.color, 10);\n    },\n\n    /*\n      Styles\n      */\n    containerStyle() {\n      return {\n        background: `repeating-linear-gradient(135deg, ${this.color} 0%, ${\n          this.color\n        } 2%, ${this.darkenColor} 2%, ${this.darkenColor} 4%)`\n      };\n    },\n    backgroundColorStyle() {\n      return { backgroundColor: this.color };\n    },\n    darkenBackgroundColorStyle() {\n      return { backgroundColor: this.darkenColor };\n    },\n    textColorStyle() {\n      return { color: this.color };\n    }\n  },\n\n  methods: {\n    selectCode() {\n      this.$refs['codeField'].select();\n    },\n\n    // クリップボードコピー機能を有効にする\n    initializeClipboardCopy() {\n      const clipboard = new window.Clipboard('.vue-copy_btn');\n      const showClipedTooltip = function(target, msg) {\n        $(target)\n          .attr('data-tooltip', msg)\n          .addClass('c-tooltip c-tooltip--show');\n        setTimeout(\n          () => $(target).removeClass('c-tooltip c-tooltip--show'),\n          1500\n        );\n      };\n      clipboard.on('success', e => showClipedTooltip(e.trigger, 'Copied!'));\n      clipboard.on('error', function(e) {\n        let msg;\n        if (/iPhone|iPad/i.test(window.navigator.userAgent)) {\n          msg = 'No support :(';\n        } else if (/Mac/i.test(window.navigator.userAgent)) {\n          msg = 'Press ⌘-C to copy';\n        } else {\n          msg = 'Press Ctrl-C to copy';\n        }\n        showClipedTooltip(e.trigger, msg);\n      });\n    }\n  },\n\n  mounted() {\n    this.initializeClipboardCopy();\n  }\n};\n</script>\n\n<style scoped>\n.vue-container {\n  container-type: inline-size;\n  container-name: coupon-code-compornent;\n  padding: 15px;\n}\n.vue-inner {\n  display: flex;\n  justify-content: space-around;\n  background: #fff;\n  padding: 35px 20px;\n}\n.vue-content {\n  flex: 1;\n  padding: 10px 20px;\n  align-self: center;\n  text-align: center;\n}\n.vue-divider {\n  width: 1px;\n  margin: 0 10px;\n}\n.vue-title {\n  font-size: 3.6rem;\n  font-weight: bold;\n}\n.vue-discount_off {\n  font-size: 4.8rem;\n}\n.vue-title_text {\n  font-size: 3.6rem;\n}\n.vue-tagline {\n  font-size: 2.4rem;\n}\n.vue-promotion_label {\n  font-size: 2.4rem;\n}\n.vue-code {\n  display: flex;\n}\n.vue-code_field {\n  appearance: none;\n  font-size: 3.6rem;\n  font-weight: bold;\n  color: #fff;\n  padding: 5px;\n  margin: 0;\n  border: none;\n  border-radius: 0;\n  outline: none;\n  text-align: center;\n  width: 100%;\n}\n.vue-copy_btn {\n  appearance: none;\n  user-select: none;\n  touch-action: manipulation;\n  outline: 0;\n  -webkit-tap-highlight-color: transparent;\n  padding: 5px 20px;\n  font-size: 2.4rem;\n  color: #fff;\n  border: none;\n  border-radius: 0;\n  white-space: nowrap;\n}\n@container coupon-code-compornent (width <= 768px) {\n  .vue-inner {\n    flex-direction: column;\n    padding: 20px;\n  }\n  .vue-content {\n    padding: 0;\n  }\n  .vue-content:first-child {\n    padding-bottom: 20px;\n  }\n  .vue-divider {\n    display: none;\n  }\n  .vue-title {\n    font-size: 2.4rem;\n  }\n  .vue-discount_off {\n    font-size: 3.2rem;\n  }\n  .vue-title_text {\n    font-size: 2.4rem;\n  }\n  .vue-tagline {\n    font-size: 1.6rem;\n  }\n  .vue-promotion_label {\n    font-size: 1.4rem;\n  }\n  .vue-code_field {\n    font-size: 2.4rem;\n  }\n  .vue-copy_btn {\n    font-size: 1.4rem;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
